import { render, staticRenderFns } from "./Checkmark.vue?vue&type=template&id=3fee2a36&"
var script = {}
import style0 from "./Checkmark.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Checkmark.vue"
export default component.exports